import type { ReactNode } from "react";
import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

export type WorkspaceSection = "bots" | "library" | "channels" | "workflows" | "audit" | "shopping";
export type WorkspaceSidebarView = WorkspaceSection | "search" | "activity";
export const workspaceSectionPaths: Record<Exclude<WorkspaceSection, "bots">, string> = {
  library: "/app/artifacts",
  channels: "/app/channels",
  workflows: "/app/workflows",
  audit: "/app/audit",
  shopping: "/app/shopping",
};
export function workspaceSectionForPath(path: string): WorkspaceSection {
  for (const [section, prefix] of Object.entries(workspaceSectionPaths)) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return section as WorkspaceSection;
  }
  return "bots";
}
export type WorkspacePanes = {
  section: WorkspaceSection;
  sidebarView: WorkspaceSidebarView;
  selectView: (view: WorkspaceSidebarView) => void;
  sidebarHost: HTMLDivElement | null;
  setSidebarHost: (host: HTMLDivElement | null) => void;
  openNavigation: () => void;
};
export const WorkspacePanesContext = createContext<WorkspacePanes | null>(null);
export const useWorkspacePanes = () => useContext(WorkspacePanesContext);

/** A section owns its data and renders its navigation into the persistent left pane. */
export function WorkspaceSidebar({ children }: { children: ReactNode }) {
  const panes = useWorkspacePanes();
  if (!panes) return children;
  return panes.sidebarHost ? createPortal(children, panes.sidebarHost) : null;
}
